const createMuiCssBaselineStyles = () => ({
    styleOverrides: {
        '.VATAmountIcon, .VATAmountText': {
            color: 'rgba(127, 136, 152)',
        },
    },
});

export default createMuiCssBaselineStyles;
